import { ChartLineUp } from "@phosphor-icons/react";

// Brand mark that mirrors the social share image: a blue gradient tile holding a
// white chart-line icon, next to the "Tipster" + blue "Check" wordmark.
export function Logo({ size = "md", showText = true, className = "" }) {
  const dims = size === "lg"
    ? { tile: "h-10 w-10", icon: 24, rounded: "rounded-xl", text: "text-2xl" }
    : size === "sm"
    ? { tile: "h-7 w-7", icon: 16, rounded: "rounded-lg", text: "text-lg" }
    : { tile: "h-9 w-9", icon: 20, rounded: "rounded-lg", text: "text-xl" };

  return (
    <span className={`flex items-center gap-2 ${className}`}>
      <span
        className={`flex ${dims.tile} shrink-0 items-center justify-center ${dims.rounded} bg-gradient-to-br from-blue-500 to-blue-700 shadow-sm shadow-blue-500/30 ring-1 ring-inset ring-white/10`}
      >
        <ChartLineUp size={dims.icon} weight="bold" className="text-white" />
      </span>
      {showText && (
        <span className={`font-heading ${dims.text} font-extrabold tracking-tight`}>
          Tipster<span className="text-blue-600 dark:text-blue-400">Check</span>
        </span>
      )}
    </span>
  );
}
